import type {
  RegistrationApiPayload,
  RegistrationApiResponse,
  RegistrationRequest,
  RegistrationResult,
} from "./registration.types";

export const adaptRegistrationRequest = (payload: RegistrationRequest): RegistrationApiPayload => {
  const body: RegistrationApiPayload = {
    email: payload.email,
    password: payload.password,
    birth_date: payload.birthDate,
    preferred_bonus: payload.preferredBonus,
  };
  if (payload.fbp) body.fbp = payload.fbp;
  if (payload.fbc) body.fbc = payload.fbc;
  return body;
};

export const adaptRegistrationResponse = (response: RegistrationApiResponse): RegistrationResult => ({
  accessToken: response.data.data.access_token,
  refreshToken: response.data.data.refresh_token ?? null,
});
